<template>
  <div class="home">
    <div class="header">
      <div class="container">
        <img src="/pc/static/img/poker/logo.png" class="logo">
      </div>
    </div>

    <div class="club center">
      <img :src="title_img" class="title_img">

      <div class="btns" @click="toScroll">
        <span>Contact Us</span>
      </div>

      <a class="email" href="mailto:pppokerglobal@gmail.com">pppokerglobal@gmail.com</a>
    </div>

    <div class="bar center">
      <p>For Poker Lovers by Poker Lovers</p>
    </div>

    <div class="content container">
      <div class="con" v-if="info" v-html="info">
      </div>
      <div v-else class="con">
        <p>Come and build your online poker club with PPPoker:</p>
        <ul>
          <li>No rental cost</li>
          <li>Lower management cost</li>
          <li>Not limited by geographical location</li>
          <li>Poker club income and player revenue at a glance</li>
          <li>Unlimited opening of tables</li>
        </ul>
        <img src="/pc/static/img/poker/con_bg.png" class="con_bg">
        <p>We provide 24/7 customer service and 1-on-1 VIP consultation.</p>
      </div>
    </div>

    <div class="sub_page">
      <router-view></router-view>
    </div>

    <div class="footer center">
      <p>pokerlovers.net © 2019 All rights Reserved</p>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  data () {
    return {
      title_img: '/pc/static/img/poker/title.png',
      info: ''
    }
  },
  methods: {
    toScroll () {
      document
        .querySelector('.sub_page')
        .scrollIntoView({ block: 'start', behavior: 'smooth' })
      document
        .querySelector('.el-form input').focus()
    }
  },
  created () {
    this.$axios.get('/poker-api/contact_us/get_info', {
      params: this.$route.query
    }).then((res) => {
      if (res.status === 200 && res.data.code === 0) {
        this.info = res.data.data.body
        this.title_img = res.data.data.main_img || '/pc/static/img/poker/title.png'
      }else {
        this.title_img = '/pc/static/img/poker/title.png'
      }
    }).catch((error) => {
      alert('network issue, Please try again later.')
    })
  }
}
</script>

<style lang="scss">
h1,
h2,
h3,
h4,
h5,
p,
span,
a {
  margin: 0px;
  padding: 0px;
}
.container {
  width: 1100px;
  margin: 0 auto;
}
.center {
  text-align: center;
}

.home .content {
  .con {
    ul {
      margin: 0px;
    }
    p,
    li {
      font-size: 22px;
      line-height: 40px;
      color: #54595f;
    }
    img {
      margin: 20px 0px;
    }
  }
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.home {
  position: relative;
  .header {
    position: relative;
    width: 100%;
    height: 82px;
    background-color: #1f1f1f;
    .container {
      height: 100%;
      display: flex;
      align-items: center;
      .logo {
        width: 143px;
      }
    }
  }
  .club {
    position: relative;
    width: 100%;
    height: 611px;
    background-color: #262626;
    .title_img {
      margin-top: 78px;
      margin-bottom: 148px;
      width: 926px;
    }
    .btns {
      background-image: url("/pc/static/img/poker/btn.png");
      background-size: cover;
      background-position: center;
      margin: 0 auto;
      width: 288px;
      height: 54px;
      cursor: pointer;
      margin-bottom: 26px;
      span {
        font-size: 20px;
        color: #ffffff;
        line-height: 54px;
      }
    }
    .email {
      color: #999999;
      font-size: 18px;
      box-shadow: 0 1px;
      &:hover {
        color: rgb(235, 231, 231);
      }
    }
  }
  .bar {
    position: relative;
    width: 100%;
    height: 82px;
    background-color: #f2f2f2;
    p {
      color: #54595f;
      font-size: 22px;
      line-height: 82px;
    }
  }
  .content {
    position: relative;
    display: flex;
    justify-content: center;
    margin: 40px auto;
    .con {
      ul {
        margin: 0px;
      }
      p,
      li {
        font-size: 22px;
        line-height: 40px;
        color: #54595f;
      }
      .title {
        color: #339933;
      }
      .con_bg {
        margin: 20px 0px;
      }
    }
  }
  .sub_page {
    position: relative;
    width: 100%;
    height: 570px;
    background-color: #f7f7f7;
  }
  .footer {
    position: relative;
    height: 66px;
    width: 100%;
    background-color: #1f1f1f;
    p {
      color: #808080;
      font-size: 20px;
      line-height: 66px;
    }
  }
}
</style>
